// @flow
import { mapKeys } from 'lodash';
import type { SignUpDeliveryMethodActionType } from './actions';

export const initialState: DeliveryMethodStateType = {
  selected: null,
  choices: {},
  order: [],
};

export default (state: DeliveryMethodStateType = initialState, action: SignUpDeliveryMethodActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_DELIVERY_METHOD':
      const { deliveryMethod } = action.payload;
      return {
        ...state,
        selected: deliveryMethod,
      };

    case 'SIGNUP_RESET_DELIVERY_METHOD':
      return initialState;

    case 'SIGNUP_SET_DELIVERY_METHODS':
      const { methods, hasGeolocation } = action.payload;
      const initialChoices = methods
        .map(method => {
          const type = method.DeliveryType === 'P' ? 'PREMIUM' : 'STANDARD';
          const hours = method.SLAHours;
          const disabled = type === 'PREMIUM' && (method.AvailabilityEndDT === null || !hasGeolocation);
          return {
            id: method.DeliveryType + '-' + method.DeliveryPartner + '-' + method.SLAHours,
            disabled,
            price: method.Price + method.TaxAmount, // with tax
            type,
            duration: hours ? (type === 'STANDARD' ? Math.floor(hours / 24) : hours) : 'N/C',
            characteristics: method,
          };
        })
        .sort((choiceA, choiceB) => choiceA.characteristics.SLAHours - choiceB.characteristics.SLAHours);

      const standardChoices = initialChoices.filter(choice => choice.type === 'STANDARD');
      const standardChoice = standardChoices.find(choice => !choice.disabled) || standardChoices[0];
      const premiumChoices = initialChoices.filter(choice => choice.type === 'PREMIUM');
      const orderedChoices: Array<any> = [standardChoice].filter(Boolean).concat(premiumChoices);

      const defaultSelectedChoice =
        orderedChoices.find(choice => choice.type === 'PREMIUM' && !choice.disabled) ||
        orderedChoices.find(choice => choice.type === 'STANDARD' && !choice.disabled) ||
        orderedChoices[0];

      return {
        ...state,
        selected: defaultSelectedChoice ? defaultSelectedChoice.id : null,
        choices: mapKeys(orderedChoices, choice => choice.id),
        order: orderedChoices.map<string>(choice => choice.id),
      };

    default:
      return state;
  }
};

export type DeliveryMethodStateType = {|
  choices: DeliveryMethodChoicesType,
  price?: number,
  selected: ?string,
  order: string[],
|};

export type DeliveryMethodChoicesType = {
  [string]: DeliveryMethodChoiceType,
};

export type DeliveryMethodChoiceType = {
  id: string,
  price: number,
  disabled: boolean,
  type: 'PREMIUM' | 'STANDARD',
  characteristics: Object,
};
